import { Box } from "@mui/material";
import { FC } from "react";
import { LayoutProps } from "Interfaces/LayoutProps";
import { useAppSelector } from "redux/store";

export const PageLayout: FC<LayoutProps> = ({ children }) => { 
    const isStandalone = useAppSelector((state) => state.configState.isStandalone);

    return (
        <Box
        sx={{
            width: "100%",
            backgroundColor: "#d9d9d9",
            msOverflowStyle: "none",  /* IE y Edge */
            scrollbarWidth: "none",  /* Firefox */
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            overflowY:  (isStandalone)? "auto" : "hidden" /* Agrega scroll vertical */,
            minHeight: "calc(100vh - 96px)" /* Ajusta la altura del contenido para llenar el espacio restante */,
            height:
            (isStandalone)? "calc(100vh - 96px)" : "auto" /* Ajusta la altura del contenido para llenar el espacio restante */,
        }}
        >
            {children}
        </Box>
    )
}